/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CompositeSearchEnhancedFilterConditionType } from './CompositeSearchEnhancedFilterConditionType';

export type CompositeSearchEnhancedFilterUdfDate = {
    filterType: CompositeSearchEnhancedFilterUdfDate.filterType;
    conditionType: CompositeSearchEnhancedFilterConditionType;
    value: Array<string>;
};

export namespace CompositeSearchEnhancedFilterUdfDate {

    export enum filterType {
        UDF_DATE1 = 'udfDate1',
        UDF_DATE2 = 'udfDate2',
        UDF_DATE3 = 'udfDate3',
    }


}

